import { Directive, ElementRef, ChangeDetectorRef, NgZone, Renderer2, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Platform } from '../platform/index';
import 'rxjs/add/operator/debounceTime';
export var FocusStatus;
(function (FocusStatus) {
    /**mouse and/or touch*/
    FocusStatus["DEFAULT"] = "default";
    /** keyboard and/or program*/
    FocusStatus["KEYBOARD"] = "keyboard";
})(FocusStatus || (FocusStatus = {}));
var LyFocusState = /** @class */ (function () {
    function LyFocusState(elementRef, _ngZone, _renderer, _cd) {
        var _this = this;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this.stateMap = new Map();
        this._eventHandlers = new Map();
        this._stateSubject = new Subject();
        this.lyFocusChange = new EventEmitter();
        if (Platform.isBrowser) {
            this._eventHandlers
                .set('focus', this.on.bind(this))
                .set('blur', this.on.bind(this))
                .set('touchstart', this.on.bind(this))
                .set('mousedown', this.on.bind(this));
            var element = elementRef.nativeElement;
            this.setTriggerElement(element);
            var on = function (event) {
                _this.stateMap.set(event.type, true);
                _this._updateState();
            };
            var ob = this._stateSubject.asObservable();
            this._stateSubscription = ob
                .debounceTime(111)
                .subscribe(function (e) {
                _this.state = e;
                _this._updateClass();
                _this.lyFocusChange.emit(e);
            });
        }
    }
    LyFocusState.prototype._updateState = function () {
        var state;
        if (this.stateMap.has('blur')) {
            this.stateMap.clear();
        }
        else if (this.stateMap.has('focus') && this.stateMap.has('mousedown') || this.stateMap.has('focus') && this.stateMap.has('touchstart')) {
            state = FocusStatus.DEFAULT;
        }
        else if (this.stateMap.has('focus')) {
            state = FocusStatus.KEYBOARD;
        }
        this._stateSubject.next(state);
    };
    LyFocusState.prototype.on = function (event) {
        this.stateMap.set(event.type, true);
        this._updateState();
    };
    LyFocusState.prototype._updateClass = function () {
        var _this = this;
        var element = this._containerElement;
        var state = this.state;
        var toggleClass = function (className, shouldSet) { return shouldSet ? _this._renderer.addClass(element, className) : _this._renderer.removeClass(element, className); };
        toggleClass("ly-focused", !!state);
        for (var key in FocusStatus) {
            if (FocusStatus.hasOwnProperty(key)) {
                var className = FocusStatus[key];
                toggleClass("ly-" + className + "-focused", state === className);
            }
        }
    };
    LyFocusState.prototype.setTriggerElement = function (element) {
        var _this = this;
        if (this._containerElement) {
            this._eventHandlers.forEach(function (fn, type) {
                _this._containerElement.removeEventListener(type, fn);
            });
        }
        if (element) {
            this._ngZone.runOutsideAngular(function () {
                return _this._eventHandlers.forEach(function (fn, type) {
                    return element.addEventListener(type, fn);
                });
            });
        }
        this._containerElement = element;
    };
    LyFocusState.prototype.ngOnDestroy = function () {
        if (Platform.isBrowser) {
            this._stateSubscription.unsubscribe();
            this.setTriggerElement(null);
        }
    };
    LyFocusState.decorators = [
        { type: Directive, args: [{
                    selector: '[lyFocusState]',
                    exportAs: 'lyFocusState'
                },] },
    ];
    /** @nocollapse */
    LyFocusState.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: NgZone, },
        { type: Renderer2, },
        { type: ChangeDetectorRef, },
    ]; };
    LyFocusState.propDecorators = {
        "lyFocusChange": [{ type: Output },],
    };
    return LyFocusState;
}());
export { LyFocusState };
//# sourceMappingURL=focus-state.directive.js.map